import React from "react";
import loaderVideo from "../images/loading3.webm";

function Loader() {
  return (
    <div id="global-loader">
      <video
        src={loaderVideo}
        className="loader-img"
        autoPlay
        loop
        muted
        playsInline
      />
      <style>{`
        #global-loader {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100vh;
          opacity: 1;
          visibility: visible;
          color: #f5f5ff;
          position: fixed;
          width: 100%;
          z-index: 999999;
          background-color: #f5f5ff;
          transition: opacity 1s ease-in-out;
        }
        .loader-img {
          position: absolute;
          right: 0;
          bottom: 0;
          top: 38%;
          left: 0;
          margin: 0 auto;
          text-align: center;
          width: 450px;
          max-width: 90%;
        }
      `}</style>
    </div>
  );
}

export default Loader;
